import colors from './Toyota/colors/colors';
import fonts from './Toyota/fonts/fonts';
import Icons from './assets/icons/index';

const theme = {
  colors,
  fonts,
  Icons,
};

export default theme;
